import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Producto',
    href: '#producto'
  }, {
    name: 'Cómo funciona',
    href: '#como-funciona'
  }, {
    name: 'Ejemplos',
    href: '#ejemplos'
  }, {
    name: 'Precio',
    href: '#pricing'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/80 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-203">
      <div className="container mx-auto px-4 flex items-center justify-between" data-id="element-204">
        {/* Logo */}
        <a href="#" className="flex items-center group" data-id="element-205">
          <span className="font-extrabold text-xl md:text-2xl tracking-tight group-hover:opacity-80 transition-opacity" style={{
          fontFamily: "'Sora', sans-serif"
        }} data-id="element-206">
            <span className="text-red-500" data-id="element-207">100</span>
            <span className="text-white" data-id="element-208">ads</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-209">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors" data-id="element-210">
              {link.name}
            </a>)}
        </div>

        {/* CTA */}
        <div className="hidden md:block" data-id="element-211">
          <a href="#pricing" className="bg-white text-black hover:bg-gray-200 px-5 py-2.5 rounded-full font-bold text-sm transition-all transform hover:-translate-y-0.5 shadow-lg hover:shadow-white/20" data-id="element-212">
            Empezar ahora
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-213">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-214" /> : <MenuIcon className="w-6 h-6" data-id="element-215" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-216">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-black/95 backdrop-blur-xl border-b border-white/10 overflow-hidden" data-id="element-217">
            <div className="flex flex-col p-4 space-y-4" data-id="element-218">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-gray-300 hover:text-white py-2 border-b border-white/5" onClick={() => setIsMobileMenuOpen(false)} data-id="element-219">
                  {link.name}
                </a>)}
              <a href="#pricing" className="bg-purple-600 text-white text-center py-3 rounded-xl font-bold mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-220">
                Empezar ahora
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}